/**
 * Custom Product Video Button & Modal
 * Portal pattern: Modal is moved to body level to escape parent stacking contexts
 */

(function () {
  'use strict';

  // Portal container - modals are moved here
  let portalContainer = null;

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Get or create portal container
    portalContainer = document.getElementById('custom-product-video-modal-portal');
    if (!portalContainer) {
      portalContainer = document.createElement('div');
      portalContainer.id = 'custom-product-video-modal-portal';
      document.body.appendChild(portalContainer);
    }

    const productGalleries = document.querySelectorAll('product-gallery');
    
    productGalleries.forEach(function (gallery) {
      initVideoButton(gallery);
    });

    // Handle theme editor section loads
    document.addEventListener('shopify:section:load', function (event) {
      const sectionId = event.detail?.sectionId;
      if (sectionId) {
        const gallery = document.querySelector('product-gallery[form*="' + sectionId + '"]');
        if (gallery) {
          initVideoButton(gallery);
        }
      }
    });

    // Keep c-buybox-delivery in sync with variant changes (sold-out vs available)
    document.addEventListener('variant:change', function (event) {
      const variant = event.detail?.variant;
      const formId = event.detail?.formId;
      if (!variant || !formId) return;
      const form = document.forms[formId];
      if (!form) return;
      const deliveryBlock = form.closest('product-rerender')?.querySelector('.c-buybox-delivery');
      if (!deliveryBlock) return;
      const available = !!variant.available;
      deliveryBlock.classList.toggle('c-buybox-delivery--sold-out', !available);
      const statusEl = deliveryBlock.querySelector('.c-buybox-delivery__status');
      if (statusEl) {
        statusEl.hidden = !available;
      }
    });
  }

  function initVideoButton(gallery) {
    const videoButtons = gallery.querySelectorAll('[data-product-video-button]');
    const videoModal = gallery.querySelector('[data-product-video-modal]');
    const videoElement = gallery.querySelector('[data-product-video-element]');

    if (!videoButtons.length || !videoModal || !videoElement) {
      return;
    }

    // Portal: Move modal to body level if not already there
    if (videoModal.parentElement !== portalContainer) {
      portalContainer.appendChild(videoModal);
    }

    // Store reference to trigger for focus return
    let previousActiveElement = null;
    
    // Store previous inline styles for defensive override
    let headerPrevStyle = null;
    let buyboxPrevStyle = null;

    // Bind click events to ALL video button triggers
    videoButtons.forEach(function (videoButton) {
      const triggerButton = videoButton.querySelector('.custom-product-video-button__trigger');
      if (triggerButton) {
        triggerButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          previousActiveElement = document.activeElement;
          openModal();
        });
      }
    });

    // Close modal handlers
    const closeButtons = videoModal.querySelectorAll('[data-product-video-close]');
    const closeButton = closeButtons[0]; // Store first close button for focus
    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    });

    // Close on overlay click (but not on dialog content)
    const overlay = videoModal.querySelector('.custom-product-video-modal__overlay');
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          closeModal();
        }
      });
    }

    // Close on ESC key (only when modal is open)
    function handleEscape(e) {
      if (e.key === 'Escape' && !videoModal.hidden) {
        closeModal();
      }
    }
    document.addEventListener('keydown', handleEscape);

    function openModal() {
      // Show modal
      videoModal.hidden = false;
      
      // Global state: mark modal as open
      document.documentElement.classList.add('has-video-modal-open');
      
      // Scroll lock: prevent background scrolling
      document.documentElement.classList.add('is-modal-open');
      document.body.classList.add('is-modal-open');
      
      // Defensive JS: Neutralize sticky elements by overriding inline styles
      // Target the actual sticky section wrapper (not store-header element)
      const headerWrap = document.querySelector('#shopify-section-sections--25373473603851__header') || 
                         document.querySelector('header.shopify-section--header') ||
                         document.querySelector('.shopify-section--header');
      const buybox = document.querySelector('safe-sticky.product-info');
      
      // Store previous inline styles for restoration
      if (headerWrap) {
        headerPrevStyle = headerWrap.getAttribute('style');
        headerWrap.style.cssText += '; position: relative !important; top: auto !important; z-index: 0 !important; transform: none !important; filter: none !important; pointer-events: none !important;';
      }
      
      if (buybox) {
        buyboxPrevStyle = buybox.getAttribute('style');
        buybox.style.cssText += '; position: relative !important; top: auto !important; z-index: 0 !important; transform: none !important; filter: none !important; will-change: auto !important;';
      }
      
      // Accessibility: Focus close button
      if (closeButton) {
        setTimeout(function() {
          closeButton.focus();
        }, 100);
      }
      
      // Load and play video
      if (videoElement.paused) {
        videoElement.load();
        videoElement.play().catch(function (err) {
          console.warn('Video autoplay failed:', err);
        });
      }
    }

    function closeModal() {
      // Hide modal
      videoModal.hidden = true;
      
      // Global state: remove modal open flag
      document.documentElement.classList.remove('has-video-modal-open');
      
      // Scroll unlock: restore background scrolling
      document.documentElement.classList.remove('is-modal-open');
      document.body.classList.remove('is-modal-open');
      
      // Defensive JS: Restore previous inline styles
      // Target the actual sticky section wrapper (not store-header element)
      const headerWrap = document.querySelector('#shopify-section-sections--25373473603851__header') || 
                         document.querySelector('header.shopify-section--header') ||
                         document.querySelector('.shopify-section--header');
      const buybox = document.querySelector('safe-sticky.product-info');
      
      if (headerWrap) {
        if (headerPrevStyle === null) {
          headerWrap.removeAttribute('style');
        } else {
          headerWrap.setAttribute('style', headerPrevStyle);
        }
        headerPrevStyle = null;
      }
      
      if (buybox) {
        if (buyboxPrevStyle === null) {
          buybox.removeAttribute('style');
        } else {
          buybox.setAttribute('style', buyboxPrevStyle);
        }
        buyboxPrevStyle = null;
      }
      
      // Accessibility: Return focus to trigger element
      if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        previousActiveElement.focus();
        previousActiveElement = null;
      }
      
      // Pause and reset video
      if (!videoElement.paused) {
        videoElement.pause();
      }
      videoElement.currentTime = 0;
    }
  }
})();

